@if (workCenterType$ | async; as workCenterType) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: workCenterType }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: workCenterType }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <div class="flex layout-col">
      <mat-tab-group class="flex" animationDuration="0ms" elderTabGroupRouting="wcTypeDetailTab">
        <!-- Tab Overview -->
        <mat-tab label="{{ 'context.overview' | translate }}">
          <elder-basic-pane-layout class="full">
            <!-- General -->
            <elder-pane class="flex layout-col">
              <elder-pane-header>
                <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                      <mat-icon>delete</mat-icon>
                      <span>{{ 'actions.delete' | translate }}</span>
                    </button>
                  </mat-menu>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content>
                <form #mainFrm="ngForm" class="flex layout-row gap-xl">
                  <div class="flex layout-col">
                    <div class="layout-row">
                      <div class="flex layout-col">
                        <!-- Identifications -->
                        <elder-pane-subtitle>{{
                          'context.identification' | translate
                        }}</elder-pane-subtitle>
                        <div class="layout-col gap-md">
                          <mat-form-field class="flex">
                            <mat-label>{{ 'context.abbreviation' | translate }}</mat-label>
                            <input
                              matInput
                              name="abbreviation"
                              required
                              placeholder="{{ 'context.abbreviation' | translate }}"
                              [(ngModel)]="workCenterType.abbreviation"
                            />
                          </mat-form-field>
                          <mat-form-field class="flex">
                            <mat-label>{{ 'context.name' | translate }}</mat-label>
                            <input
                              matInput
                              name="name"
                              required
                              placeholder="{{ 'context.name' | translate }}"
                              [(ngModel)]="workCenterType.name"
                            />
                          </mat-form-field>
                          <mat-form-field class="flex">
                            <mat-label>{{ 'context.description' | translate }}</mat-label>
                            <input
                              matInput
                              name="description"
                              placeholder="{{ 'context.description' | translate }}"
                              [(ngModel)]="workCenterType.description"
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex layout-col">
                    <div class="flex layout-row gap-xl">
                      <!-- WorkCenterType's capabilities -->
                      <div class="flex layout-col">
                        <elder-pane-subtitle>{{
                          'capabilities.capabilities' | translate
                        }}</elder-pane-subtitle>
                        <div class="flex outlined">
                          <elder-table
                            class="flex"
                            [data]="wctCapabilities$ | async"
                            [selectionMultiEnabled]="true"
                            [selectionVisible]="true"
                          >
                            <elder-data-toolbar
                              *elderTableToolbar
                              [canMore]="false"
                              [canAdd]="false"
                              [canRemove]="true"
                              (requestRemove)="onRemoveCapabilities($event)"
                            >
                              <ng-template [elderToolbarContent]="'left'">
                                <mat-form-field subscriptSizing="dynamic">
                                  <elder-select
                                    name="addOperation"
                                    appCapabilitySpecSelect
                                    [excludeIds]="wctCapabilitiesIds"
                                    placeholder="{{ 'capabilities.add' | translate }}"
                                    (valueChange)="onAddCapability($event)"
                                    [value]="dummyCapability"
                                  >
                                  </elder-select>
                                </mat-form-field>
                              </ng-template>
                            </elder-data-toolbar>
                            <!-- name Column -->
                            <ng-container matColumnDef="name">
                              <th mat-header-cell *matHeaderCellDef>
                                {{ 'context.name' | translate }}
                              </th>
                              <td mat-cell *matCellDef="let capability">{{ capability.name }}</td>
                            </ng-container>
                            <!-- description Column -->
                            <ng-container matColumnDef="description">
                              <th mat-header-cell *matHeaderCellDef>
                                {{ 'context.description' | translate }}
                              </th>
                              <td mat-cell *matCellDef="let capability">
                                {{ capability.description }}
                              </td>
                            </ng-container>
                          </elder-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
        <!-- Tab properties -->
        <mat-tab label="{{ 'properties.title' | translate }}">
          <elder-basic-pane-layout class="full">
            <elder-pane class="flex layout-col">
              <elder-pane-header>
                <elder-pane-title>{{ 'properties.title' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content padding="0" class="p-0">
                <app-property-spec-table
                  class="full"
                  [propertyKinds]="[PropertyKind.WORK_CENTER]"
                  [(specs)]="workCenterType.propertySpecs"
                >
                </app-property-spec-table>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
        <!-- Tab item properties -->
        <mat-tab label="{{ 'positions.properties' | translate }}">
          <!-- TODO: move save into toolbar, move inner panes up -->
          <elder-basic-pane-layout class="full">
            <elder-pane class="flex layout-col">
              <elder-pane-header>
                <elder-pane-title>{{ 'positions.properties' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content class="flex" padding="16px">
                <app-dynamic-property-spec-browser
                  class="flex"
                  [propertyKinds]="[PropertyKind.PRODUCT, PropertyKind.ITEM]"
                  [(dynamicPropertySpecs)]="workCenterType.dynamicPropertySpecs"
                >
                </app-dynamic-property-spec-browser>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
        <!-- Tab Item sort -->
        <mat-tab label="{{ 'context.itemsSort' | translate }}">
          <elder-basic-pane-layout class="full">
            <elder-pane class="flex layout-col">
              <elder-pane-header>
                <elder-pane-title>{{ 'context.itemsSort' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content class="flex" padding="0">
                <app-item-sort-spec-detail
                  class="flex"
                  [(itemSortSpec)]="workCenterType.itemSortSpec"
                >
                </app-item-sort-spec-detail>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
        <!-- Filter specs -->
        <mat-tab label="{{ 'positions.filters' | translate }}">
          <elder-basic-pane-layout class="full">
            <elder-pane class="flex layout-col">
              <elder-pane-header>
                <elder-pane-title>{{ 'positions.filters' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content class="flex" padding="0">
                <app-constraint-spec-table
                  class="flex"
                  [(constraints)]="workCenterType.filterSpecs"
                >
                </app-constraint-spec-table>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}

<ng-template #header let-workCenterType>
  @if (creationMode) {
    <span>
      {{ 'shopfloor.workcenters.types.new' | translate }}
    </span>
  } @else {
    <elder-header
      [header]="'shopfloor.workcenters.types.type' | translate"
      [subheader]="'ID: ' + workCenterType.id"
    >
    </elder-header>
  }
</ng-template>
